import {
  firstDayEarlyVoting,
  totalCumulativeVotes,
  totalCumulativeRegVoters,
  numberOfDaysResults,
  top10CumulativeVotes,
  top10totalCumulativeRegVoters,
} from './stats';
import { intcomma, ordinal } from 'journalize';
import { apPercentFormat, apDateFormatMoment } from '../utils/chart-utils';

// get the slots
// let earlyVotingDate = document.querySelector('#early-voting-date'),
// dayEarlyVoting = document.querySelector('#day-of-early-voting'),
let numberEarlyVotes = document.querySelector('#number-early-votes'),
  percentEarlyVotes = document.querySelector('#percent-early-votes'),
  numberEarlyVotesTop10 = document.querySelector('#number-early-votes-top-10'),
  percentEarlyVotesTop10 = document.querySelector(
    '#percent-early-votes-top-10'
  );

// earlyVotingDate.textContent = apDateFormatMoment(
//   new Date(firstDayEarlyVoting.clone().add(numberOfDaysResults - 1, 'days'))
// );

// set day of early voting
let ordinalDay = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'sixth',
  'seventh',
  'eighth',
  'ninth',
];

// if (numberOfDaysResults <= ordinalDay.length)
//   dayEarlyVoting.textContent = ordinalDay[numberOfDaysResults - 1];
// else dayEarlyVoting.textContent = ordinal(numberOfDaysResults);

// set number of early votes
// COMMENT THIS OUT FOR TOP 10 VERSION
numberEarlyVotes.textContent = intcomma(totalCumulativeVotes);

// set percent of votes
// COMMENT THIS OUT FOR TOP 10 VERSION
percentEarlyVotes.textContent = apPercentFormat(
  totalCumulativeVotes / totalCumulativeRegVoters
);

// set the number of votes from the top 10 counties as of day
numberEarlyVotesTop10.textContent = intcomma(top10CumulativeVotes);

percentEarlyVotesTop10.textContent = apPercentFormat(
  top10CumulativeVotes / top10totalCumulativeRegVoters
);

// let numberEarlyVotesTop15 = document.querySelector('#number-early-votes-top-15');

// let fraction2016EV = document.querySelector('#fraction-early-votes-2016'),
// fraction2012EV = document.querySelector('#fraction-early-votes-2012'),
// dayEarlyVoting2016 = document.querySelector('#day-of-early-voting-2016');

// dayEarlyVoting2016.textContent = numberOfDaysResults;

// set the number of votes from the top 15 counties as of day
// numberEarlyVotesTop15.textContent = intcomma(top15CumulativeVotes);

// // set fraction of 2016 as of the day
// fraction2016EV.textContent = apPercentFormat(
//   top15CumulativeVotes / top15CumulativeVotes2016
// );

// // set fraction of 2012 as of the day
// fraction2012EV.textContent = apPercentFormat(
//   top15CumulativeVotes / top15CumulativeVotes2012
// );
